import React, { Component } from "react";
import { Switch } from "react-router";
import { Layout } from "./Layout";
import { RouteWithLayout } from "./RouteWithLayout";
import { SurchargePage } from "../pages/surcharge/SurchargePage";

export class SurchargeSwitch extends Component {
  render() {
    return (
      <Switch>
        <RouteWithLayout layout={Layout} exact path="/" component={SurchargePage} />
      </Switch>
    );
  }
}
